/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ amount: NonNullable<unknown> }} Carrier_Form_Cod_Override_Order_PaidInputs */

const vi_carrier_form_cod_override_order_paid = /** @type {(inputs: Carrier_Form_Cod_Override_Order_PaidInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Đơn đã thanh toán đủ. Nhập số này, bưu tá sẽ thu thêm ${i?.amount}đ của khách.`)
};

/**

* @param {Carrier_Form_Cod_Override_Order_PaidInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const carrier_form_cod_override_order_paid = /** @type {((inputs: Carrier_Form_Cod_Override_Order_PaidInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Form_Cod_Override_Order_PaidInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_carrier_form_cod_override_order_paid(inputs)
});